import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';

// Hooks
import { useStores } from 'hooks/use-stores';
import Location from 'models/Location';

import { DropdownArrow, NoData, NoDataText, Placeholder, LocationDropdownSelect } from './styles';

interface LocationDropdownProps {
  locations: Location[];
  onSearch: (event: any) => void;
  dropdownText: string;
}

function LocationDropdown({ locations, onSearch, dropdownText }: LocationDropdownProps) {
  const [options, setOptions] = useState([]);
  const { uiState } = useStores();
  const { windowDimensions } = uiState;

  useEffect(() => {
    setOptions(
      locations.map(({ locationName, locationShortId }) => ({
        label: locationName,
        value: locationShortId,
      }))
    );
  }, [locations]);

  return (
    <LocationDropdownSelect
      dropdownClassName="location-dropdown__select"
      listHeight={windowDimensions.height * 0.33}
      onChange={onSearch}
      options={options}
      notFoundContent={
        <NoData>
          <NoDataText>No locations currently available</NoDataText>
        </NoData>
      }
      placeholder={
        <Placeholder>
          {dropdownText}
          <DropdownArrow />
        </Placeholder>
      }
      showArrow={false}
    />
  );
}

export default observer(LocationDropdown);
